import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ICumulativeLoginClaimResponse } from 'models/vip/i-cumulative-login.interface';

import { claimCumulativeLoginReward } from 'services/cumulative-login.service';

import { queryKeys } from './query-keys';

export interface UseClaimCumulativeLoginReturn {
  claim: () => Promise<ICumulativeLoginClaimResponse>;
  loading: boolean;
  error: string | null;
  data: ICumulativeLoginClaimResponse | null;
  reset: () => void;
}

export const useClaimCumulativeLoginMutation = (): UseClaimCumulativeLoginReturn => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () =>
      claimCumulativeLoginReward(new AbortController().signal).then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.cumulativeLogin.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.vipPoints.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.vipLevels.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.vipUser.all });
    },
  });

  return {
    claim: async (): Promise<ICumulativeLoginClaimResponse> => {
      return await mutation.mutateAsync();
    },
    loading: mutation.isPending,
    error: mutation.error
      ? mutation.error instanceof Error
        ? mutation.error.message
        : 'Failed to claim reward'
      : null,
    data: mutation.data ?? null,
    reset: mutation.reset,
  };
};
